/**
 * @ Author: mzc
 * @ Create Time: 2024-07-03 19:51:46
 * @ Modified by: mzc
 * @ Modified time: 2024-08-13 14:24:33
 * @ Description: 购物中心
 */
import dayjs from "dayjs";

const initalState = {
	categoryId: 0,
	keyword: "",
	showSearch: false
};
const procurementCenterReducer = (state = initalState, action) => {
	switch (action.type) {
		case "PROCUREMENTCENTER_UPDATE_KEYWORD":
			return { ...state, keyword: action.payload };
		case "PROCUREMENTCENTER_UPDATE_SHOWSEARCH":
			return { ...state, showSearch: action.payload };
		case "PROCUREMENTCENTER_UPDATE_ACTIVEKEY":
			return { ...state, categoryId: action.payload };
		case "PROCUREMENTCENTER_RESET":
			return { ...JSON.parse(JSON.stringify(initalState)) };
		default:
			return state;
	}
};

export default procurementCenterReducer;
